"use strict";

import { lcvOrdersConstants } from "../_constants/lcvOrders.constants";

export const INITIAL_LCV_ORDERS_STATE = {
     preview : null,
     importResult : null,
     importHistory : { items: [], totalCount: 0 },
};

export function lcvOrders(state = INITIAL_LCV_ORDERS_STATE, action) {
    switch (action.type) {
     // The BFF unwraps the gateway envelope, so the payload is already the bare result.
     case lcvOrdersConstants.LCV_ORDERS_PREVIEW_IMPORT_COMPLETE:
          return {
               ...state,
               preview: action.payload || null,
               importResult: null,
          };
     case lcvOrdersConstants.LCV_ORDERS_IMPORT_COMPLETE:
          return {
               ...state,
               importResult: action.payload || null,
          };
     case lcvOrdersConstants.LCV_ORDERS_CLEAR_IMPORT:
          return {
               ...state,
               preview: null,
               importResult: null,
          };
     case lcvOrdersConstants.LCV_ORDERS_GET_IMPORT_HISTORY_COMPLETE:
          return {
               ...state,
               importHistory: action.payload || { items: [], totalCount: 0 },
          };
     default:
          return state;
    }
}
